import moment from 'moment';
import pluralize from 'pluralize';

import { isAlbum } from '../../../../../../../../../util/album';
import { isAlbumFolder } from '../../../../../../../../../util/album-folder';

/**
 * Determines the Hierarchy Item's subtitle based on what the item is.
 *
 * @param {Object} hierarchyItem The hierarchy item; a Folder, Album or Membership
 * @param {String} subtitleProp a subtitle passed as a prop, takes priority.
 * @returns {string|string|*}
 */
export const getHierarchyItemSubtitle = (hierarchyItem, subtitleProp) => {
  if (subtitleProp) {
    return subtitleProp;
  }

  if (!hierarchyItem) {
    return '';
  }

  const isFolderEntity = isAlbumFolder(hierarchyItem);
  const isAlbumEntity = isAlbum(hierarchyItem);

  // Folder
  if (isFolderEntity) {
    const count = hierarchyItem.album_photos?.total;

    if (count === 0) {
      return !hierarchyItem.parent ? 'Empty gallery' : 'Empty folder';
    }

    if (count) {
      return `${count} ${pluralize('photo', count)}`;
    }

    return '';
  }

  // Album
  if (isAlbumEntity) {
    const count = hierarchyItem.is_video_album
      ? hierarchyItem?.videos?.total ?? 0
      : hierarchyItem?.photos?.total ?? 0;

    if (count > 0) {
      return `${count} ${pluralize(
        hierarchyItem?.is_video_album ? 'video' : 'photo',
        count,
      )}`;
    }

    return '';
  }

  // Album Membership
  if (!isFolderEntity && !isAlbumEntity && hierarchyItem.album) {
    const now = moment();
    const { album } = hierarchyItem;
    const photoCount = hierarchyItem.matched_photos_extended?.total;

    const lastUploadedDiff = album.last_uploaded_at
      ? now.diff(album.last_uploaded_at, 'days')
      : 0;

    const subtitleLastUploaded =
      lastUploadedDiff > 0 ? ` • ${lastUploadedDiff}d ago` : '';

    return !photoCount
      ? `No matches${subtitleLastUploaded}`
      : `${photoCount} ${pluralize(
          'match',
          photoCount,
        )}${subtitleLastUploaded}`;
  }

  return '';
};
